import { useState } from 'react'

export type ListPageSize = 20 | 50

export function useListPagination() {
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState<ListPageSize>(20)

  const changePageSize = (value: ListPageSize) => {
    setLimit(value)
    setPage(1)
  }

  return { page, setPage, limit, changePageSize }
}
